var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9984 3.65625C30.6984 3.65625 36.0578 5.875 40.0891 9.90625C44.1203 13.9375 46.3391 19.2969 46.3391 24.9984C46.3391 30.6984 44.1203 36.0578 40.0891 40.0891C36.0578 44.1203 30.6984 46.3391 24.9984 46.3391C19.2969 46.3391 13.9375 44.1203 9.90625 40.0891C5.875 36.0578 3.65625 30.6984 3.65625 24.9984C3.65625 19.2969 5.875 13.9375 9.90625 9.90625C13.9375 5.875 19.2969 3.65625 24.9984 3.65625ZM6.99063 24.9984C6.99063 15.0688 15.0688 6.99063 24.9984 6.99063C34.9266 6.99063 43.0047 15.0688 43.0047 24.9984C43.0047 34.9266 34.9266 43.0047 24.9984 43.0047C15.0688 43.0047 6.99063 34.9266 6.99063 24.9984Z",
    fill: "url(#hinava_random_uuid_135849673675959695424403305845088212993)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 33.1818V16.8182C22.5 15.814 21.6045 15 20.5 15C19.3954 15 18.5 15.814 18.5 16.8182V33.1818C18.5 34.186 19.3954 35 20.5 35C21.6045 35 22.5 34.186 22.5 33.1818Z",
    fill: "url(#hinava_random_uuid_249678939711883528770611351018748443572)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 33.1818V16.8182C31.5 15.814 30.6045 15 29.5 15C28.3954 15 27.5 15.814 27.5 16.8182V33.1818C27.5 34.186 28.3954 35 29.5 35C30.6045 35 31.5 34.186 31.5 33.1818Z",
    fill: "url(#hinava_random_uuid_151382972985958095419243274919142186753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_135849673675959695424403305845088212993",
    x1: 24.9977,
    y1: 3.65625,
    x2: 24.9977,
    y2: 46.3391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_249678939711883528770611351018748443572",
    x1: 24.9977,
    y1: 3.65625,
    x2: 24.9977,
    y2: 46.3391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_151382972985958095419243274919142186753",
    x1: 24.9977,
    y1: 3.65625,
    x2: 24.9977,
    y2: 46.3391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.e22c07fc6fe7314f73e164b68e30a814.svg";
export { ForwardRef as ReactComponent };